<template>
  <div>
    <div style="display: flex">
      <button @click="getGeo">update</button>
      <!-- <span class="cursive">lat {{lat}}</span> -->
      <!-- <span class="cursive">lng {{lng}}</span> -->
    </div>

    <div>
      <gmap-map
        :center="center"
        :zoom="15"
        style="width: 100%; height: calc(100vh - 210px)"
      >
        <gmap-marker
          v-for="(m, index) in markers"
          :key="index"
          :position="m.position"
          :clickable="true"
          :draggable="true"
          @click="center=m.position"
        >
        </gmap-marker>
      </gmap-map>

      <!-- <gmap&#45;street&#45;view&#45;panorama class="pano" :position="center" :zoom="1"> -->
      <!-- </gmap&#45;street&#45;view&#45;panorama> -->
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      // getGeo用
      pref: [
        { name: '未選択', value: 0 },
        { name: '北海道', value: 1 },
        { name: '青森県', value: 2 },
        { name: '秋田県', value: 3 },
        { name: '岩手県', value: 4 },
        { name: '山形県', value: 5 },
        { name: '宮城県', value: 6 },
        { name: '福島県', value: 7 },
        { name: '栃木県', value: 8 },
        { name: '山梨県', value: 9 },
        { name: '群馬県', value: 10 },
        { name: '茨城県', value: 11 },
        { name: '千葉県', value: 12 },
        { name: '埼玉県', value: 13 },
        { name: '東京都', value: 14 },
        { name: '神奈川県', value: 15 },
        { name: '静岡県', value: 16 },
        { name: '長野県', value: 17 },
        { name: '愛知県', value: 18 },
        { name: '岐阜県', value: 19 },
        { name: '新潟県', value: 20 },
        { name: '富山県', value: 21 },
        { name: '石川県', value: 22 },
        { name: '福井県', value: 23 },
        { name: '滋賀県', value: 24 },
        { name: '京都府', value: 25 },
        { name: '三重県', value: 26 },
        { name: '和歌山県', value: 27 },
        { name: '奈良県', value: 28 },
        { name: '大阪府', value: 29 },
        { name: '兵庫県', value: 30 },
        { name: '鳥取県', value: 31 },
        { name: '島根県', value: 32 },
        { name: '岡山県', value: 33 },
        { name: '広島県', value: 34 },
        { name: '山口県', value: 35 },
        { name: '高知県', value: 36 },
        { name: '徳島県', value: 37 },
        { name: '香川県', value: 38 },
        { name: '愛媛県', value: 39 },
        { name: '福岡県', value: 40 },
        { name: '佐賀県', value: 41 },
        { name: '長崎県', value: 42 },
        { name: '熊本県', value: 43 },
        { name: '宮崎県', value: 44 },
        { name: '大分県', value: 45 },
        { name: '鹿児島県', value: 46 },
        { name: '沖縄県', value: 47 }
      ]
    }
  },

  computed: {
    lat () {
      return Number(this.$store.getters.tutor.lat)
    },

    lng () {
      return Number(this.$store.getters.tutor.lng)
    },

    center () {
      return { lat: this.lat, lng: this.lng }
    },

    markers () {
      return [{ position: { lat: this.lat, lng: this.lng } }]
    }
  },

  methods: {
    getGeo () {
      this.$store.dispatch('getGeo', {
        this: this,
        tutor: this.$store.getters.tutor,
        pref: this.pref
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* .pano { */
/*   width: 500px; */
/*   height: 300px; */
/* } */

button {
  display: inline-block;
  font-size: 10px;
  padding: 7px 5px;
  text-decoration: none;
  background: #fff;
  color: #37474f;
  border: solid 1px #ccc;
  border-radius: 0px;
  margin-right: 1px;
  cursor: pointer;
  width: 60px;
  outline: 0;
}

.cursive {
  font-family: cursive;
  padding: 7px;
}
</style>



// WEBPACK FOOTER //
// TutorMap2.vue?1bde5274